define.alias("shared/components/shared/post/secondary/high-performer/wrapper", "calendar/components/shared/post/secondary/high-performer/wrapper");